import './change-client-info.scss';

import { Modal } from 'antd';
import { useEffect } from 'react';
import { Controller, useForm } from 'react-hook-form';

import { Button, Input } from '@/components/Shared/ui';

interface IProps {
  defaultValues?: ClientFormInterface;
  onSave: (values: ClientFormInterface) => void;
  isOpened: boolean;
  onClose: (isOpened: boolean) => void;
}

const ChangeClientInfo: React.FC<IProps> = ({
  defaultValues,
  onSave,
  isOpened,
  onClose
}) => {
  const {
    control,
    formState: { errors },
    handleSubmit,
    reset
  } = useForm<ClientFormInterface>({ mode: 'all', delayError: 200 });

  const handleClose = () => {
    onClose(false);
    reset(defaultValues);
  };

  const onSubmit = (values: ClientFormInterface) => {
    onSave(values);
    onClose(false);
  };

  useEffect(() => {
    if (defaultValues) reset(defaultValues);
  }, [defaultValues]);

  return (
    <Modal
      centered
      mask={{ closable: true }}
      className="change-client-info"
      title="Введите ФИО"
      open={isOpened}
      onCancel={handleClose}
      footer={null}
    >
      <form
        onSubmit={handleSubmit(onSubmit)}
        className="change-client-info__form"
      >
        <Controller
          control={control}
          name="lastName"
          rules={{
            required: 'Пожалуйста, введите данные',
            minLength: { value: 1, message: 'Пожалуйста, введите данные' }
          }}
          render={({ field, fieldState: { error } }) => (
            <div className="change-client-info__item">
              <Input
                {...field}
                label="Фамилия"
                value={field.value ?? ''}
                error={error?.message}
                isRequired
              />
            </div>
          )}
        />
        <Controller
          control={control}
          name="firstName"
          rules={{
            required: 'Пожалуйста, введите данные',
            minLength: { value: 1, message: 'Пожалуйста, введите данные' }
          }}
          render={({ field, fieldState: { error } }) => (
            <div className="change-client-info__item">
              <Input
                {...field}
                label="Имя"
                value={field.value ?? ''}
                error={error?.message}
                isRequired
              />
            </div>
          )}
        />
        <Controller
          control={control}
          name="middleName"
          rules={{
            required: 'Пожалуйста, введите данные',
            minLength: { value: 1, message: 'Пожалуйста, введите данные' }
          }}
          render={({ field, fieldState: { error } }) => (
            <div className="change-client-info__item">
              <Input
                {...field}
                label="Отчество"
                value={field.value ?? ''}
                error={error?.message}
                isRequired
              />
            </div>
          )}
        />

        <div className="change-client-info__actions">
          <Button type="button" onClick={handleClose}>
            Отмена
          </Button>
          <Button
            variant="filled-red"
            disabled={Object.values(errors).length !== 0}
          >
            Сохранить
          </Button>
        </div>
      </form>
    </Modal>
  );
};

export default ChangeClientInfo;

interface ClientFormInterface {
  firstName: string;
  lastName: string;
  middleName: string;
}
